import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from "react-router-dom";
import { ROUTES } from "./routes";

const router = createBrowserRouter(
  createRoutesFromElements(
    ROUTES.map((route) => (
      <Route key={route.path} path={route.path} element={ <route.page />} />
    ))
  )
);

const AppRouter: React.FC = (): React.ReactElement => {
  return <RouterProvider router={router} />
};

export default AppRouter;